import service from './service'
import MD5 from 'js-md5'

export function request (method, url, params, ...pathParams) {
  let signTime = new Date().getTime()
  let signStr = ''
  if (params && Object.keys(params).length > 0) {
    signStr += JSON.stringify(sortAsc(params, method))
  }
  if (pathParams && pathParams.length > 0) {
    url = url + '/' + pathParams.join('/')
    signStr += pathParams.join('')
  }
  signStr += signTime
  const config = {
    url,
    method,
    headers: {
      sign: MD5(signStr).toUpperCase(),
      // sign:signStr,
      signTime: signTime,
      contentType: 'application/json'
    }
  }
  if (params) {
    if (method === 'get') {
      config['params'] = params
    } else {
      config['data'] = params
    }
  }
  return service(config)
}
function sortAsc (jsonObj, method) {
  let arr = new Array()
  let num = 0
  for (let i in jsonObj) {
    arr[num] = i
    num++
  }
  let sortArr = arr.sort()
  let sortObj = {}
  for (let i in sortArr) {
    var objValue = jsonObj[sortArr[i]]
    if (typeof objValue === 'object') {
      objValue = sortAsc(objValue)
    } else if (typeof objValue === 'number' && method !== 'post') {
      objValue = objValue + ''
    }
    sortObj[sortArr[i]] = objValue
  }
  return sortObj
}



// WEBPACK FOOTER //
// ./src/untils/request.js